import { ChangeEvent, useState } from 'react'
import BrandedLogo from '../components/branded-logo'
import CustomInput from '../components/CustomInput'
import CustomButton from '../components/CustomButton'
import Loader from '../components/Loader'
import { toast } from 'react-toastify'
import { ParseErrors } from '../utils/ParseErrors'
import axiosInstance from '../utils/axiosInstance'
import { useNavigate, useSearchParams } from 'react-router-dom'

const ResetPassword = () => {
    const navigation = useNavigate()
    const [values, setValues] = useState<any>({
        password: "",
        cpassword: "",
    })
    const [loading, setIsLoading] = useState(false)
    const [searchParams] = useSearchParams()
    const ref_id = searchParams.get("ref_id")

    // ------------------------------- [ HANDLE LOGIN ] -------------------------------
    const HandleResetPassword = async () => {
        if (Validate()) {
            setIsLoading(true)
            try {
                await axiosInstance.put(`/auth/reset-password/${ref_id}`, values)
                toast.success("Password Updated successfully")
                setIsLoading(false)
                navigation("/auth")
            } catch (error) {
                toast.error(ParseErrors(error))
                setIsLoading(false)
            }
        }
    }

    // ---------------------- [  VALIDATION FUNCTION ] ----------------------

    const Validate = () => {
        if (!values.password) {
            toast.error("Please enter a password")
            return false
        } else if (!values.cpassword) {
            toast.error("Please confirm your password")
            return false
        } else if (values.cpassword !== values.password) {
            toast.error("Password and Confirm Password must be same")
            return false
        } else {
            return true
        }
    }


    // ---------------------- [  ON INPUT CHANGE SET VALUES ] ----------------------
    const onChangeValues = (e: ChangeEvent<HTMLInputElement>) => {
        setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const RedirectToLogin = () => {
        navigation("/auth")
    }

    return (
        <div className='w-[100%] h-[100vh] bg-background flex items-center justify-between smallTablet:flex-col smallTablet:justify-start smallTablet:h-auto smallTablet:min-h-[100dvh] smallTablet:py-8 smallTablet:gap-4 smallTablet:overflow-x-hidden'>
            {/* AUTH PAGE LOGO */}
            <div className="w-[45%] h-[100%] flex items-center justify-center relative smallTablet:w-full smallTablet:h-auto" >
                <div className='h-[400px] w-[450px] smallTablet:w-[280px] smallTablet:h-[160px] blur-3xl rounded-[50%] bg-indigo-600/20 animate-pulse absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]'></div>
                <div className="p-[30px] text-center border-r-[50%] relative animate-fade-in-slow mobile:p-4">
                    <p className="text-[55px] smallTablet:text-[35px]">👋</p>
                    <h4 className="text-text-secondary text-[28px] smallTablet:text-[22px] font-medium">Welcome to</h4>
                    <BrandedLogo alt="" className="w-[300px] smallTablet:w-[200px] mt-2 h-[auto] object-contain mx-auto" />
                </div>
            </div>
            {/* AUTH PAGE LOGO */}


            {/* LOGIN AND RESET FORM */}


            <div className='w-[55%] h-full flex items-center justify-center smallTablet:w-full smallTablet:h-auto smallTablet:px-4'>
                <div className={`w-[55%] max-w-[430px] h-[480px] smallTablet:w-full relative [perspective:1000px] `}>
                    <div className={`h-full w-full relative transition-all duration-500`}>

                        {/*------------------------------- LOGIN FORM --------------------- */}
                        <div className={`absolute inset-0 py-[40px] px-[50px] smallTablet:px-8 smallTablet:py-8 mobile:!px-5 bg-surface border border-edge rounded-2xl shadow-overlay animate-fade-in`}>
                            <div >
                                <h2 className="text-center text-[26px] mobile:text-[22px] font-heading-font bg-gradient-heading bg-clip-text text-transparent">RESET PASSWORD</h2>
                                <div className=' my-8'>
                                    <CustomInput title="Password" label='Password' name='password' type='password' onChange={onChangeValues} />
                                    <div className='my-6'></div>
                                    <CustomInput title="Confirm Password" label='Confirm Password' name='cpassword' type='password' onChange={onChangeValues} />

                                    <CustomButton variant="primary" className='w-full mt-[55px] !text-base' onClick={HandleResetPassword}>{loading ? <Loader /> : "SUBMIT"}</CustomButton>
                                    <p className='text-base text-blue hover:text-text-primary transition-colors font-medium cursor-pointer mt-6 text-center' onClick={RedirectToLogin}>Back to Login?</p>
                                </div>
                            </div>
                        </div>
                        {/*------------------------------- LOGIN FORM --------------------- */}



                    </div>
                </div>
            </div>




            {/* LOGIN AND RESET FORM */}
        </div>
    )
}

export default ResetPassword
